import { Quote } from "lucide-react";

/**
 * LearnerStoriesStrip — shows approved learner quotes on an instructor's
 * Professional Passport and marketplace card. Always uses the moderated
 * public shape (quote + display_name + test_date). Renders nothing when
 * there are no approved stories yet.
 */
export default function LearnerStoriesStrip({ stories, variant = "passport" }) {
  if (!stories || stories.length === 0) return null;
  const compact = variant === "card";
  return (
    <section data-testid="learner-stories-strip" className={`rounded-2xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-4 ${compact ? "" : "mt-1"}`}>
      <div className="flex items-center gap-2 mb-3 text-slate-500 dark:text-slate-400">
        <Quote className="w-4 h-4" />
        <p className="text-xs font-extrabold uppercase tracking-wider">Learner stories</p>
        <span className="ml-auto text-[10px] text-slate-400">{stories.length} verified</span>
      </div>
      <div className={`grid gap-2 ${compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2"}`}>
        {stories.slice(0, compact ? 2 : 6).map((s) => (
          <figure
            key={s.id}
            data-testid={`learner-story-${s.id}`}
            className="rounded-xl bg-gradient-to-br from-emerald-50 to-sky-50 dark:from-emerald-900/15 dark:to-sky-900/15 border border-emerald-100 dark:border-emerald-900/40 p-3"
          >
            <blockquote className="text-[12px] leading-snug text-slate-700 dark:text-slate-200">
              "{s.quote}"
            </blockquote>
            <figcaption className="mt-2 text-[10px] font-extrabold uppercase tracking-wider text-emerald-700 dark:text-emerald-300">
              — {s.display_name}
              {s.test_date && <span className="ml-1 text-slate-400 dark:text-slate-500 font-bold normal-case">· passed {s.test_date}</span>}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
